export default import.meta.ROLLUP_FILE_URL_b2a5e256